var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content fba-order" },
    [
      _c(
        "order-grid",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          ref: "orderGrid",
          attrs: { "view-source": "fbaOrder", "config-module": "101" },
          on: {
            rowDoubleClicked: function($event) {
              return _vm.toLook()
            }
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "look", type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.toLook()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
              ),
              _vm.$checkPermission(["button_FBAOrder_editFbaBookingOrders"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "edit", type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.toEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_newFbaBookingOrders"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "Clone", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toCopy()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_newFbaBookingOrders"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "Add", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("FbaChannel.addOrder")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_newFbaBookingOrders"])
                ? _c(
                    "el-dropdown",
                    { staticStyle: { margin: "0 5px" } },
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_Import_OnOrder")) +
                            " "
                        ),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right"
                        })
                      ]),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticStyle: { width: "144px" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown"
                        },
                        [
                          _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "uploadOrderSingle",
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    action: _vm.URL.seaExport.batchImportFbaJob,
                                    headers: _vm.headers,
                                    "show-file-list": false,
                                    accept: ".xls, .xlsx",
                                    "before-upload": _vm.beforeOrderUpload,
                                    "on-success": _vm.uploadOrderSuccessBatch,
                                    "on-error": _vm.handleError,
                                    data: {
                                      deptId: Number(_vm.curDepId),
                                      fileIdx: "",
                                      branchId: _vm.curOfficeId,
                                      lob: "FBA"
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "padding-left": "0px",
                                        color: "#6F6F6F",
                                        "text-align": "left",
                                        width: "130px",
                                        "word-break": "break-all",
                                        "white-space": "normal"
                                      },
                                      attrs: { slot: "trigger", type: "text" },
                                      slot: "trigger"
                                    },
                                    [
                                      _c("span", [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/fba-import.png")
                                          }
                                        })
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("FbaJob.batchImportOrder")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "padding-left": "0px",
                                    color: "#6F6F6F",
                                    "text-align": "left",
                                    width: "130px",
                                    "word-break": "break-all",
                                    "white-space": "normal"
                                  },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadBatchTemplateSingle()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadBatchImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { divided: "" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "uploadOrderSingle",
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    action: _vm.URL.fba.singleImport,
                                    headers: _vm.headers,
                                    "show-file-list": false,
                                    accept: ".xls, .xlsx",
                                    "before-upload": _vm.beforeOrderUpload,
                                    "on-success": _vm.uploadOrderSuccessSingle,
                                    "on-error": _vm.handleError,
                                    data: {
                                      deptId: Number(_vm.curDepId),
                                      fileIdx: "",
                                      officeId: _vm.curOfficeId
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "padding-left": "0px",
                                        color: "#6F6F6F",
                                        "text-align": "left",
                                        width: "130px",
                                        "word-break": "break-all",
                                        "white-space": "normal"
                                      },
                                      attrs: { slot: "trigger", type: "text" },
                                      slot: "trigger"
                                    },
                                    [
                                      _c("span", [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/fba-import.png")
                                          }
                                        })
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("FbaJob.importSingleOrder")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "padding-left": "0px",
                                    color: "#6F6F6F",
                                    "text-align": "left",
                                    width: "130px",
                                    "word-break": "break-all",
                                    "white-space": "normal"
                                  },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadTemplateSingle()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/fba-download.png")
                                      }
                                    })
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "FbaJob.downloadSingleImportTemplate"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_notSubmitFbaBookingOrder"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "notSubmit", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toNotSubmit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_HoldSubmission")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_submitFbaBookingOrder"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "submit", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toSubmit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                  )
                : _vm._e(),
              _vm.$checkPermission(["button_FBAOrder_deleteFbaBookingOrder"])
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "Delete", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.toDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c("order-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "orderWorkspace",
        attrs: { "parent-context": _vm.context, "view-source": "fbaOrder" },
        on: {
          back: _vm.backToList,
          copy: _vm.toCopy,
          notSubmit: _vm.toNotSubmit,
          submit: _vm.toSubmit
        }
      }),
      _c("job-copy-window", {
        attrs: { visible: _vm.copyDialog.visible, lob: "fba" },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.doCopyJob
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }